const axios = require('axios');

if (isNode()) {
  var fs = require('fs');
}

// TODO: Better document what these constants are
// TODO: Document each function please
const CD_SIGNATURE = 0x02014b50;
const VERSION_NEEDED_TO_EXTRACT_UTF8 = 20;
const CENTRAL_DIRECTORY_RECORD_FIXED_SIZE = 46;
const LOCAL_FILE_HEADER_FIXED_SIZE = 30;
const VERSION_NEEDED_TO_EXTRACT_ZIP64 = 45;
const END_OF_CENTRAL_DIRECTORY_RECORD_SIZE = 22;
// 3 = unix. 63 = spec version 6.3
const VERSION_MADE_BY = (3 << 8) | 63;
const FILE_NAME_IS_UTF8 = 1 << 11;
const UNKNOWN_CRC32_AND_FILE_SIZES = 1 << 3;
const NO_COMPRESSION = 0;
const DATA_DESCRIPTOR_SIZE = 16;
const cp437 =
  '\u0000☺☻♥♦♣♠•◘○◙♂♀♪♫☼►◄↕‼¶§▬↨↑↓→←∟↔▲▼ !"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~⌂ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ';

/**
 * TdfNavigator -
 *
 * This class is used to extract parts of a TDF. You may pull bytes of a given range from a
 * or request specific important chunks like the 'manifest', or 'payload'.
 */
class TdfNavigator {
  constructor(dataSource) {
    this._dataSource = dataSource;
    this._fileSize = null; // Not used for all data source types. So far, just the 'file-node' type.
  }

  /**
   * getChunk - retrieve a chunk of data correspondin to a certain byte range
   * @param {number} byteStart
   * @param {Number} byteEnd
   */
  async getChunk(byteStart, byteEnd) {
    let chunk;
    switch (this._dataSource.type) {
      // convert 'stream' type to a flat buffer on first read.
      case 'stream':
        var buf = await this.dumpStreamToBuffer(this._dataSource.location);
        this._dataSource = { type: 'buffer', location: buf }; // FIXME:
        return await this.getChunk(byteStart, byteEnd);

      case 'remote':
        let rangeHeader = `${byteStart}`;

        if (byteEnd) {
          rangeHeader += `-${byteEnd - 1}`;
        }

        chunk = await getRemoteChunk(this._dataSource.location, rangeHeader);
        break;

      case 'file-node':
        const filePath = this._dataSource.location;

        if (!this._fileSize) {
          this._fileSize = fs.statSync(filePath).size;
        }

        let start = byteStart;
        let end = byteEnd - 1;

        if (byteStart < 0) {
          // max with 0 for the case where the chunk size is larger than the file size.
          start = Math.max(0, this._fileSize - Math.abs(byteStart));
          end = this._fileSize;
        }

        const fileLocation = this._dataSource.location;
        const rs = fs.createReadStream(fileLocation, { start, end });

        const buffers = [];

        rs.on('data', (buff) => {
          buffers.push(buff);
        });

        chunk = await new Promise((resolve) => {
          rs.on('end', () => {
            resolve(Buffer.concat(buffers));
          });
        });
        break;

      case 'file-browser':
        const fileRef = this._dataSource.location;
        const chunkBlob = fileRef.slice(byteStart, byteEnd);
        chunk = await new Response(chunkBlob).arrayBuffer();
        break;

      case 'buffer':
        const buffer = this._dataSource.location;
        chunk = buffer.slice(byteStart, byteEnd);
        break;

      default:
        throw new Error(
          `Data source type not defined, or not supported: ${this._dataSource.type}}`
        );
    }

    return chunk;
  }

  /**
   * If provided a 'stream' type, dump it all into a buffer.
   * FIXME: Introduce TDF stream implementation to allow reasonable chunking for this case.
   */
  async dumpStreamToBuffer(stream) {
    const bufs = [];
    const that = this;
    stream.on('data', function (d) {
      bufs.push(d);
    });
    return await new Promise((resolve) => {
      stream.on('end', function () {
        resolve(Buffer.concat(bufs));
      });
    });
  }

  /**
   * Utility function to get the centralDirectory for the zip file.
   * @param  {Buffer} chunkBuffer Takes a buffer of a portion of the file
   * @return {Object}             The central directory represented as an object
   */
  async getCentralDirectory() {
    const chunk = await this.getChunk(-1000);
    // TODO: Does this need to be tuned??!?
    // Full buffer for the file chunk
    const chunkBuffer = Buffer.from(chunk);
    // Slice off the EOCDR (End of Central Directory Record) part of the buffer so we can figure out the CD size
    const cdBuffers = this.getCDBuffers(chunkBuffer);

    return cdBuffers.map(this.parseCDBuffer.bind(this));
  }

  /**
   * Gets the manifest
   * @returns {Buffer} The manifest as a buffer represented as JSON
   */
  /* istanbul ignore next */
  async getManifest(cdBuffers, fileName) {
    const cdObj = cdBuffers.filter((cdBuffer) => cdBuffer.fileName === fileName)[0];
    if (!cdObj) {
      throw new Error('Unable to retrieve CD');
    }
    const byteStart = cdObj.relativeOffsetOfLocalHeader + cdObj.headerLength;
    const byteEnd = byteStart + cdObj.uncompressedSize;
    const manifest = await this.getChunk(byteStart, byteEnd);
    const manifestBuffer = Buffer.from(manifest);
    return JSON.parse(manifestBuffer.toString());
  }

  async getPayloadSegment(cdBuffers, fileName, encrpytedSegmentOffset, encryptedSegmentSize) {
    const cdObj = cdBuffers.filter((cdBuffer) => cdBuffer.fileName === fileName)[0];
    if (!cdObj) {
      throw new Error('Unable to retrieve CD');
    }
    const byteStart =
      cdObj.relativeOffsetOfLocalHeader + cdObj.headerLength + encrpytedSegmentOffset;
    // TODO: what's the exact byte start?
    const byteEnd = byteStart + encryptedSegmentSize;

    const chunk = await this.getChunk(byteStart, byteEnd);
    const segmentBuffer = Buffer.from(chunk);
    return segmentBuffer;
  }

  /**
   * Takes a portion of a ZIP (must be the last portion of a ZIP to work) and returns an array of Buffers
   * that correspond to each central directory.
   * @param  {Buffer} chunkBuffer The last portion of a zip file
   * @returns {Array}             An array of buffers
   */
  getCDBuffers(chunkBuffer) {
    const cdBuffers = [];
    let lastBufferOffset = chunkBuffer.length;
    for (let i = chunkBuffer.length - 22; i >= 0; i -= 1) {
      // If what we're locking at isn't the start of a central directory, skip it..
      if (chunkBuffer.readUInt32LE(i) !== CD_SIGNATURE) {
        // eslint-disable-next-line no-continue
        continue;
      }
      // Slice off that CD from it's start until the end of either the buffer, or whatever the start of the previously
      // found CD was
      cdBuffers.push(chunkBuffer.slice(i, lastBufferOffset));
      // Store the last offset location so we know how to slice off hte next CD.
      lastBufferOffset = i;
      // We can skip over 22 iterations since we know the minimum size of a CD is 22.
      i -= 22;
    }

    // They should be in the correct order. Since we iterate backwards, it's built backwards.
    return cdBuffers.reverse();
  }

  /**
   * Takes a central directory buffer and turns it into a manageable object
   * that represents the CD
   * @param  {Buffer} cdBuffer The central directory buffer to parse
   * @return {Object}          The CD object
   */
  parseCDBuffer(cdBuffer) {
    if (cdBuffer.readUInt32LE(0) !== CD_SIGNATURE) {
      return new Error('Invalid central directory file header signature');
    }
    const cd = {};
    // 4 - Version made by
    cd.versionMadeBy = cdBuffer.readUInt16LE(4);
    // 6 - Version needed to extract (minimum)
    cd.versionNeededToExtract = cdBuffer.readUInt16LE(6);
    // 8 - General purpose bit flag
    cd.generalPurposeBitFlag = cdBuffer.readUInt16LE(8);
    // 10 - Compression method
    cd.compressionMethod = cdBuffer.readUInt16LE(10);
    // 12 - File last modification time
    cd.lastModFileTime = cdBuffer.readUInt16LE(12);
    // 14 - File last modification date
    cd.lastModFileDate = cdBuffer.readUInt16LE(14);
    // 16 - CRC-32
    cd.crc32 = cdBuffer.readUInt32LE(16);
    // 20 - Compressed size
    cd.compressedSize = cdBuffer.readUInt32LE(20);
    // 24 - Uncompressed size
    cd.uncompressedSize = cdBuffer.readUInt32LE(24);
    // 28 - File name length (n)
    cd.fileNameLength = cdBuffer.readUInt16LE(28);
    // 30 - Extra field length (m)
    cd.extraFieldLength = cdBuffer.readUInt16LE(30);
    // 32 - File comment length (k)
    cd.fileCommentLength = cdBuffer.readUInt16LE(32);
    // 34 - Disk number where file starts
    // 36 - Internal file attributes
    cd.internalFileAttributes = cdBuffer.readUInt16LE(36);
    // 38 - External file attributes
    cd.externalFileAttributes = cdBuffer.readUInt32LE(38);
    // 42 - Relative offset of local file header
    cd.relativeOffsetOfLocalHeader = cdBuffer.readUInt32LE(42);
    const fileNameBuffer = cdBuffer.slice(46, 46 + cd.fileNameLength);
    // eslint-disable-next-line no-bitwise
    const isUtf8 = cd.generalPurposeBitFlag & 0x800;
    cd.fileName = bufferToString(fileNameBuffer, 0, cd.fileNameLength, isUtf8);
    cd.headerLength = 30 + cd.fileNameLength + cd.extraFieldLength;

    return cd;
  }

  getLocalFileHeader(utf8FileName, crc32, compressedSize, uncompressedSize) {
    const fixedSizeStuff = new Buffer(LOCAL_FILE_HEADER_FIXED_SIZE);
    let generalPurposeBitFlag = FILE_NAME_IS_UTF8;
    // we can't know the size in advance
    // TODO: this means we need to add a data descriptor!
    generalPurposeBitFlag |= UNKNOWN_CRC32_AND_FILE_SIZES;
    const dateModified = dateToDosDateTime(new Date());
    const filenameBuffer = Buffer.from(utf8FileName);
    // local file header signature     4 bytes  (0x04034b50)
    fixedSizeStuff.writeUInt32LE(0x04034b50, 0);
    // version needed to extract       2 bytes
    fixedSizeStuff.writeUInt16LE(VERSION_NEEDED_TO_EXTRACT_UTF8, 4);
    // general purpose bit flag        2 bytes
    fixedSizeStuff.writeUInt16LE(generalPurposeBitFlag, 6);
    // compression method              2 bytes
    fixedSizeStuff.writeUInt16LE(NO_COMPRESSION, 8);
    // last mod file time              2 bytes
    fixedSizeStuff.writeUInt16LE(dateModified.time, 10);
    // last mod file date              2 bytes
    fixedSizeStuff.writeUInt16LE(dateModified.date, 12);
    // crc-32                          4 bytes
    fixedSizeStuff.writeUInt32LE(crc32, 14);
    // compressed size                 4 bytes
    fixedSizeStuff.writeUInt32LE(compressedSize, 18);
    // uncompressed size               4 bytes
    fixedSizeStuff.writeUInt32LE(uncompressedSize, 22);
    // file name length                2 bytes
    fixedSizeStuff.writeUInt16LE(filenameBuffer.length, 26);
    // extra field length              2 bytes
    fixedSizeStuff.writeUInt16LE(0, 28);
    return Buffer.concat([
      fixedSizeStuff,
      // file name (variable size)
      filenameBuffer,
      // extra field (variable size)
    ]);
  }

  writeDataDescriptor(crc32, uncompressedSize) {
    const buffer = new Buffer(DATA_DESCRIPTOR_SIZE);
    // optional signature (required according to Archive Utility)
    buffer.writeUInt32LE(0x08074b50, 0);
    // crc-32                          4 bytes
    buffer.writeUInt32LE(crc32, 4);
    // compressed size                 4 bytes
    buffer.writeUInt32LE(uncompressedSize, 8);
    // uncompressed size               4 bytes
    buffer.writeUInt32LE(uncompressedSize, 12);
    return buffer;
  }

  writeCentralDirectoryRecord(
    uncompressedSize,
    utf8FileName,
    normalRelativeOffsetOfLocalHeader,
    crc32,
    externalFileAttributes
  ) {
    const fixedSizeStuff = new Buffer(CENTRAL_DIRECTORY_RECORD_FIXED_SIZE);
    let generalPurposeBitFlag = FILE_NAME_IS_UTF8;
    // we can't know the size in advance
    // TODO: this means we need to add a data descriptor!
    generalPurposeBitFlag |= UNKNOWN_CRC32_AND_FILE_SIZES;
    const zeiefBuffer = new Buffer(0);
    const dateModified = dateToDosDateTime(new Date());
    const filenameBuffer = Buffer.from(utf8FileName);
    // central file header signature   4 bytes  (0x02014b50)
    fixedSizeStuff.writeUInt32LE(CD_SIGNATURE, 0);
    // version made by                 2 bytes
    fixedSizeStuff.writeUInt16LE(VERSION_MADE_BY, 4);
    // version needed to extract       2 bytes
    fixedSizeStuff.writeUInt16LE(VERSION_NEEDED_TO_EXTRACT_UTF8, 6);
    // general purpose bit flag        2 bytes
    fixedSizeStuff.writeUInt16LE(generalPurposeBitFlag, 8);
    // compression method              2 bytes
    fixedSizeStuff.writeUInt16LE(NO_COMPRESSION, 10);
    // last mod file time              2 bytes
    fixedSizeStuff.writeUInt16LE(dateModified.time, 12);
    // last mod file date              2 bytes
    fixedSizeStuff.writeUInt16LE(dateModified.date, 14);
    // crc-32                          4 bytes
    fixedSizeStuff.writeUInt32LE(crc32, 16);
    // compressed size                 4 bytes
    fixedSizeStuff.writeUInt32LE(uncompressedSize, 20);
    // uncompressed size               4 bytes
    fixedSizeStuff.writeUInt32LE(uncompressedSize, 24);
    // file name length                2 bytes
    fixedSizeStuff.writeUInt16LE(filenameBuffer.length, 28);
    // extra field length              2 bytes
    fixedSizeStuff.writeUInt16LE(zeiefBuffer.length, 30);
    // file comment length             2 bytes
    fixedSizeStuff.writeUInt16LE(0, 32);
    // disk number start               2 bytes
    fixedSizeStuff.writeUInt16LE(0, 34);
    // internal file attributes        2 bytes
    fixedSizeStuff.writeUInt16LE(0, 36);
    // external file attributes        4 bytes
    fixedSizeStuff.writeUInt32LE(externalFileAttributes, 38);
    // relative offset of local header 4 bytes
    fixedSizeStuff.writeUInt32LE(normalRelativeOffsetOfLocalHeader, 42);
    return Buffer.concat([
      fixedSizeStuff,
      // file name (variable size)
      filenameBuffer,
      // extra field (variable size)
      zeiefBuffer,
      // file comment (variable size)
      // empty comment
    ]);
  }

  writeEndOfCentralDirectoryRecord(
    normalEntriesLength,
    normalSizeOfCentralDirectory,
    normalOffsetOfStartOfCentralDirectory
  ) {
    const eocdrBuffer = new Buffer(END_OF_CENTRAL_DIRECTORY_RECORD_SIZE);
    // end of central dir signature                       4 bytes  (0x06054b50)
    eocdrBuffer.writeUInt32LE(0x06054b50, 0);
    // number of this disk                                2 bytes
    eocdrBuffer.writeUInt16LE(0, 4);
    // number of the disk with the start of the central directory  2 bytes
    eocdrBuffer.writeUInt16LE(0, 6);
    // total number of entries in the central directory on this disk  2 bytes
    eocdrBuffer.writeUInt16LE(normalEntriesLength, 8);
    // total number of entries in the central directory   2 bytes
    eocdrBuffer.writeUInt16LE(normalEntriesLength, 10);
    // size of the central directory                      4 bytes
    eocdrBuffer.writeUInt32LE(normalSizeOfCentralDirectory, 12);
    // offset of start of central directory with respect to the starting disk number  4 bytes
    eocdrBuffer.writeUInt32LE(normalOffsetOfStartOfCentralDirectory, 16);
    // .ZIP file comment length                           2 bytes
    eocdrBuffer.writeUInt16LE(0, 20);
    // .ZIP file comment                                  (variable size)
    // no comment
    return eocdrBuffer;
  }
}

/**
 * Takes a buffer, and turns it into a string
 * @param  {Buffer}  buffer The buffer to convert
 * @param  {Number}  start  The start location of the part of the buffer to convert
 * @param  {Number}  end    The end location of the part of the buffer to convert
 * @param  {Boolean} isUtf8 Is it utf8?
 * @return {String}         The converted string
 */
function bufferToString(buffer, start, end, isUtf8) {
  if (isUtf8) {
    return buffer.toString('utf8', start, end);
  }

  let result = '';
  for (let i = start; i < end; i++) {
    if (cp437[buffer[i]]) {
      result += cp437[buffer[i]];
    }
  }
  return result;
}

function dateToDosDateTime(jsDate) {
  let date = 0;
  date |= jsDate.getDate() & 0x1f; // 1-31
  date |= ((jsDate.getMonth() + 1) & 0xf) << 5; // 0-11, 1-12
  date |= ((jsDate.getFullYear() - 1980) & 0x7f) << 9; // 0-128, 1980-2108

  let time = 0;
  time |= Math.floor(jsDate.getSeconds() / 2); // 0-59, 0-29 (lose odd numbers)
  time |= (jsDate.getMinutes() & 0x3f) << 5; // 0-59
  time |= (jsDate.getHours() & 0x1f) << 11; // 0-23

  return { date, time };
}

function isNode() {
  try {
    return typeof window === 'undefined' || fs.createWriteStream === undefined;
  } catch (err) {
    return false;
  }
}

async function getRemoteChunk(url, range) {
  let chunk;

  const opts = {
    responseType: 'arraybuffer',
    headers: {
      Range: `bytes=${range}`,
    },
  };

  try {
    const res = await axios.get(url, opts);

    if (!res.data) {
      throw new Error(
        'Unexpected response type: Server should have responded with an ArrayBuffer.'
      );
    }

    chunk = res.data;
  } catch (e) {
    if (e && e.response && e.response.status === 416) {
      // Range not satisfiable, try again.
      chunk = await getRemoteChunk(url, '0');
    } else {
      // TODO: Determine if this should throw an error or not
      // console.log('Error: ', e);
    }
  }

  return chunk;
}

module.exports = TdfNavigator;
